<!-- <korviu-loader *ngIf="isLoading"></korviu-loader> -->
<div class="flex flex-col w-full items-center">
  <div class="flex flex-col items-center justify-center">
    <i nz-icon class="pb-4 sm:pb-6 w-10 h-auto sm:w-12">
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none">
        <mask
          id="mask0_6670_89476"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="48"
          height="49"
        >
          <rect y="0.5" width="48" height="48" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_6670_89476)">
          <path
            d="M22.2 33.7L36.3 19.6L33.5 16.8L22.2 28.1L16.5 22.4L13.7 25.2L22.2 33.7ZM25 44.5C22.2333 44.5 19.6333 43.975 17.2 42.925C14.7667 41.875 12.65 40.45 10.85 38.65C9.05 36.85 7.625 34.7333 6.575 32.3C5.525 29.8667 5 27.2667 5 24.5C5 21.7333 5.525 19.1333 6.575 16.7C7.625 14.2667 9.05 12.15 10.85 10.35C12.65 8.55 14.7667 7.125 17.2 6.075C19.6333 5.025 22.2333 4.5 25 4.5C27.7667 4.5 30.3667 5.025 32.8 6.075C35.2333 7.125 37.35 8.55 39.15 10.35C40.95 12.15 42.375 14.2667 43.425 16.7C44.475 19.1333 45 21.7333 45 24.5C45 27.2667 44.475 29.8667 43.425 32.3C42.375 34.7333 40.95 36.85 39.15 38.65C37.35 40.45 35.2333 41.875 32.8 42.925C30.3667 43.975 27.7667 44.5 25 44.5Z"
            fill="#0D9443"
          />
        </g>
      </svg>
    </i>
    <span class="paragraph-large outfit normal bold pb-8">{{ 'okeeyCash.congratulations' | translate }}</span>
  </div>
  <div class="paragraph-medium text-center outfit normal">{{ 'okeeyCash.congratulationMessage' | translate }}</div>
  <div *nzModalFooter class="flex flex-col w-full gap-4">
    <korviu-button color="tertiary" (click)="goToProfile()" class="w-full">{{
      'okeeyCash.goToProfile' | translate
    }}</korviu-button>
    <korviu-button color="ghost" (click)="goToDashboard()" class="w-full">{{
      'okeeyCash.goToDashboard' | translate
    }}</korviu-button>
  </div>
</div>
